<section class="home-offer">
    <div class="container">
       <div class="row">
          <div class="col-lg-8 offset-lg-2 text-sm-center">
             <div class="section-heading">
                <h5 class="sub-title">APROVECHA NUESTRAS </h5>
                <h2 class="section-title">CONSULTORÍAS DESTACADAS</h2>
                <p>Tu camino a España empieza con el paso correcto.</p>
             </div>
          </div>
       </div>
       <div class="offer-section">
          <div class="row">
             <div class="col-md-6">
                <article class="offer-item" style="background-image: url(https://voyjaleas-website.sebtec12.workers.dev/health-insurance-web-600x600.jpg);">
                   <div class="offer-badge">
                      Requisito para el visado
                   </div>
                   <div class="offer-content">
                      <div class="package-meta">
                         <ul>
                            <li>
                               <i class="fas fa-clock"></i>
                               Rápido
                            </li>
                            <li>
                              Sin complicaciones
                            </li>
                            <li>
                               <i class="fas fa-map-marker-alt"></i>España
                            </li>
                         </ul>
                      </div>
                      <h3>
                         <a href="https://app.voyjaleas.com/#/sub-app/health-helper">CONTRATA TU SEGURO MÉDICO APROBADO</a>
                      </h3>
                      <p>Elige un seguro validado por los consulados españoles. Te acompañamos paso a paso hasta obtener tu póliza. Ideal para visados de estudio, residencia o nómadas.</p>
                      <div class="price-list">
                         price: 
                         <del>$65 </del>
                         <ins>$55</ins>
                      </div>
                      <a href="https://app.voyjaleas.com/#/sub-app/health-helper" class="round-btn">CONTRATAR AHORA</a>
                   </div>
                </article>
             </div>
             <div class="col-md-6">
                <article class="offer-item" style="background-image: url(https://voyjaleas-website.sebtec12.workers.dev/student-visa-web-600x600.jpg);">
                   <div class="offer-badge">
                      Consigue tu visado sin estrés
                   </div>
                   <div class="offer-content">
                      <div class="package-meta">
                         <ul>
                            <li>Para España</li>
                            <li>
                              <i class="fas fa-user-friends"></i>
                               Acompañamiento 1 a 1
                            </li>
                         </ul>
                      </div>
                      <h3>
                         <a href="https://app.voyjaleas.com/#/sub-app/visa-helper">OBTÉN TU VISADO DE ESTUDIOS SIN ESTRÉS</a>
                      </h3>
                      <p>Resolvemos tus dudas, revisamos tus documentos y te guiamos hasta que consigas tu visado de estudios. Nuestra experiencia es tu mejor recurso.</p>
                      <div class="price-list">
                         <!-- price: 
                         <del>$1100 </del>
                         <ins>$900</ins> -->
                      </div>
                      <a href="https://app.voyjaleas.com/#/sub-app/visa-helper" class="round-btn">RESERVAR CONSULTORÍA</a>
                   </div>
                </article>
             </div>
          </div>
          <div class="section-btn-wrap text-center">
             <a href="javascript:void(0)" class="round-btn" (click)="goToCalendly()">📆 Plazas limitadas por semana – ¡Reserva antes de que se agoten!</a>
          </div>
       </div>
    </div>
 </section>
